import { createContext, useContext } from 'react';

export const ErrorReportContext = createContext(null);

export const useErrorReport = () => {
  const context = useContext(ErrorReportContext);
  if (!context) {
    throw new Error('useErrorReport must be used within ErrorReportProvider');
  }
  return context;
};
